import { useQuery  } from "react-query";
import {
  getCash,
  getOrders,
  getPayables,
  getCashForcast,
  getCollectionEffectiveness,
  getCollections,
  getDaysPayablesOutstanding,
  getDaysSalesOutstanding,
  getInsights,
  getNetCashGraph,
  getOrderForcast,
  getPayableForcast,
  getPayablesAging,
  getPaymentProcessing,
  getPaymentTermsPayables,
  getPaymentTermsReceivables,
  getReceivableForcast,
  getReceivables,
  getReceivablesAging,
  getTopCustomersHighestOrder,
  getTopCustomersHighestOutstanding,
  getTopSuppliersHighestOrder,
  getTopSuppliersHighestOutstanding,
} from "services/stats.services";

export const useCash = (tenants) => {
  return useQuery(["cash", { tenants }], () => getCash({ tenants }));
};

export const useOrders = (tenants) => {
  return useQuery(["orders", { tenants }], () => getOrders({ tenants }));
};

export const usePayables = (tenants) => {
  return useQuery(["payables", { tenants }], () => getPayables({ tenants }));
};

export const useReceivables = (tenants) => {
  return useQuery(["receivables", { tenants }], () => getReceivables({ tenants }));
};

export const useCollections = (tenants) => {
  return useQuery(["collections", { tenants }], () => getCollections({ tenants }));
};

export const useReceivableForcast = (tenants) => {
  return useQuery(["receivableForcast", { tenants }], () => getReceivableForcast({ tenants }));
};

export const useOrderForcast = (tenants) => {
  return useQuery(["orderForcast", { tenants }], () => getOrderForcast({ tenants }));
};

export const usePayableForcast = (tenants) => {
  return useQuery(["payableForcast", { tenants }], () => getPayableForcast({ tenants }));
};

export const useCashForcast = (tenants) => {
  return useQuery(["cashForcast", { tenants }], () => getCashForcast({ tenants }));
};

export const useDaysSalesOutstanding = (days, tenants) => {
  return useQuery(
    ["daysSalesOutstanding", { days, tenants }],
    () => getDaysSalesOutstanding({ days, tenants })
  );
};
export const useDaysPayablesOutstanding = (days, tenants) => {
  return useQuery(
    ["daysPayablesOutstanding", { days, tenants }],
    () => getDaysPayablesOutstanding({ days, tenants })
  );
};

export const useNetCashGraph = (tenants) => {
  return useQuery(["netcash", { tenants }], () => getNetCashGraph({ tenants }));
};

export const usePaymentTermsPayables = (tenants) => {
  return useQuery(["paymentTermsPayables", { tenants }], () => getPaymentTermsPayables({ tenants }));
};

export const usePaymentTermsReceivables = (tenants) => {
  return useQuery(["paymentTermsReceivables", { tenants }], () => getPaymentTermsReceivables({ tenants }));
};

export const useTopCustomersHighestOutstanding = (tenants) => {
  return useQuery(
    ["topCustomersHighestOutstanding", { tenants }],
    () => getTopCustomersHighestOutstanding({ tenants })
  );
};

export const useTopCustomersHighestOrder = (tenants) => {
  return useQuery(["topCustomersHighestOrder", { tenants }], () => getTopCustomersHighestOrder({ tenants }));
};

export const useTopSuppliersHighestOutstanding = (tenants) => {
  return useQuery(
    ["topSuppliersHighestOutstanding", { tenants }],
    () => getTopSuppliersHighestOutstanding({ tenants })
  );
};

export const useTopSuppliersHighestOrder = (tenants) => {
  return useQuery(["topSuppliersHighestOrder", { tenants }], () => getTopSuppliersHighestOrder({ tenants }));
};

export const useReceivablesAging = (tenants) => {
  return useQuery(["receivablesAging", { tenants }], () => getReceivablesAging({ tenants }));
};

export const usePayablesAging = (tenants) => {
  return useQuery(["payablesAging", { tenants }], () => getPayablesAging({ tenants }));
};
export const useInsights = (tenants) => {
  return useQuery(["insights", { tenants }], () => getInsights({ tenants }));
};

export const useCollectionEffectiveness = (tenants) => {
  return useQuery(["collectionEffectiveness", { tenants }], () => getCollectionEffectiveness({ tenants }));
};

export const usePaymentProcessing = (tenants) => {
  return useQuery(["paymentProcessing", { tenants }], () => getPaymentProcessing({ tenants }));
};
